import React from "react";

export const ErrorStep = () => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title red">Error</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>
          {Drupal.t("There was an error authorizing this bank transfer. Please try again, and if the problem persists, reach out to Naut Zero support.")}
        </p>
      </div>
    </div>
  </>
);
